<template>
  <section class="hero presenters-hero">
    <img src="../assets/graphics/yellow-h.svg" alt="" class="--left">
    <img src="../assets/graphics/blue-h.svg" alt="" class="--right">
    <video class="hero__background-video" autoplay muted loop>
      <source src="../assets/hero/bg.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div class="hero__overlay"></div>
    <div class="hero__content container">
      <div class="hero__content--text">
        <h1>OUR 2027</h1>
        <h2>Presenting Companies</h2>
        <a href="/agenda">
          <button class="btn-new-alt">
            SEE 2027 Agenda
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </a>
      </div>
    </div>
  </section>
</template>

<script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "../styles/components/hero.scss";
  </style>